module.exports = __webpack_public_path__ + "static/media/DSC00142.801be0e3.jpg";